import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaCheck, FaTimes, FaArrowRight, FaStar, FaBuilding } from "react-icons/fa";
import "./PricingPage.css"; // We will keep specific styles here but aligned with App.css
import SharedNavbar from "../components/SharedNavbar";
import AntigravityParticles from "../components/AntigravityParticles";
import Footer from "../components/Footer";
import LoginModal from "../components/LoginModal";

const PricingPage = () => {
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const [billingCycle, setBillingCycle] = useState("monthly");
  const [showLoginModal, setShowLoginModal] = useState(false);

  return (
    <div className="pricing-page-light">
      {/* Background Particles - Subtly behind everything */}
      <div className="particles-container">
        <AntigravityParticles />
      </div>

      {/* Navigation - Uses SharedNavbar */}
      <SharedNavbar activePage="pricing" />

      {/* Hero Section - Clean Light Theme */}
      <section className="pricing-hero-light">
        <div className="hero-content">
          <div className="hero-badge">
            <span>✨ Built for Founders</span>
          </div>
          <h1 className="hero-title-light">
            Pricing that scales with <span className="highlight-blue">clarity</span>.
          </h1>
          <p className="hero-subtext-light">
            Start for free. Upgrade to build confidence, deep clarity, and investor-ready maps.
          </p>

          {/* Hero Buttons */}
          <div className="hero-buttons" style={{ marginTop: "2rem", marginBottom: "1rem" }}>
            <button className="cta-primary" onClick={() => setShowLoginModal(true)}>
              Start Free
            </button>
            <button className="cta-secondary" onClick={() => navigate("/", { state: { target: "home" } })}>
              See Sample Maps
            </button>
          </div>

          {/* Billing Toggle */}
          <div className="toggle-wrapper">
            <div className="toggle-pill">
              <button
                className={`cycle-btn ${ billingCycle === 'monthly' ? 'active' : '' }`}
                onClick={() => setBillingCycle('monthly')}
              >
                Monthly
              </button>
              <button
                className={`cycle-btn ${ billingCycle === 'annual' ? 'active' : '' }`}
                onClick={() => setBillingCycle('annual')}
              >
                Annual
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* 3-Column Grid Section */}
      <section className="pricing-cards-section">
        <div className="pricing-container-centered">

          {/* FREE PLAN */}
          <div className="plan-card clean-card">
            <div className="card-top">
              <h3 className="plan-name">Starter Map</h3>
              <div className="plan-price">
                <span className="amount">$0</span>
                <span className="period">/ forever</span>
              </div>
              <p className="plan-desc">For first-time moonshots and quick clarity.</p>
            </div>
            <div className="card-body">
              <button className="btn-outline-dark" onClick={() => setShowLoginModal(true)}>Start Free</button>
              <ul className="feature-list">
                <li><FaCheck className="icon-green" /> 1 Active Moonshot</li>
                <li><FaCheck className="icon-green" /> Basic Map View</li>
                <li><FaCheck className="icon-green" /> Clarity Score™ Snapshot</li>
                <li><FaCheck className="icon-green" /> Community Templates</li>
              </ul>
            </div>
          </div>

          {/* FOUNDER PRO (Featured) */}
          <div className="plan-card featured-card-light">
            <div className="popular-flag">MOST POPULAR</div>
            <div className="card-top">
              <h3 className="plan-name text-blue">Founder</h3>
              <div className="plan-price">
                <span className="amount">$29</span>
                <span className="period">/ month</span>
              </div>
              <p className="plan-desc">The complete OS for founders building with evidence.</p>
            </div>
            <div className="card-body">
              <button className="btn-solid-blue" onClick={() => setShowLoginModal(true)}>Get Started</button>
              <ul className="feature-list">
                <li><FaCheck className="icon-blue" /> <strong>Unlimited Moonshots</strong></li>
                <li><FaCheck className="icon-blue" /> Full Map View + AI Chat</li>
                <li><FaCheck className="icon-blue" /> Fog Index™ + Reality Check™</li>
                <li><FaCheck className="icon-blue" /> Weekly Strategy Check-ins</li>
                <li><FaCheck className="icon-blue" /> Unlimited Exports</li>
                <li><FaCheck className="icon-blue" /> Deck & Doc Analysis</li>
              </ul>
            </div>
          </div>

          {/* TEAM PLAN */}
          <div className="plan-card clean-card">
            <div className="card-top">
              <h3 className="plan-name">Startup OS</h3>
              <div className="plan-price">
                <span className="amount">$99</span>
                <span className="period">/ month</span>
              </div>
              <p className="plan-desc">For co-founders and key operators.</p>
            </div>
            <div className="card-body">
              <button className="btn-outline-dark" onClick={() => window.location.href = "mailto:sales@moonshotmap.com"}>Contact Sales</button>
              <ul className="feature-list">
                <li><FaCheck className="icon-green" /> Everything in Pro</li>
                <li><FaCheck className="icon-green" /> 5 Team Seats Included</li>
                <li><FaCheck className="icon-green" /> Shared Workspaces</li>
                <li><FaCheck className="icon-green" /> Team Scoreboard</li>
                <li><FaCheck className="icon-green" /> Priority Support</li>
              </ul>
            </div>
          </div>

        </div>
      </section>

      {/* Enterprise / VC Section */}
      <section className="enterprise-section-light">
        <div className="enterprise-container">
          <div className="ent-content">
            <div className="ent-icon">
              <FaBuilding />
            </div>
            <div className="ent-text">
              <h3>Enterprise & Accelerators</h3>
              <p>Scalable verification for portfolios. Custom scoring weights, benchmarking overlays, and data connectors.</p>
            </div>
            <button className="ent-btn" onClick={() => window.location.href = "mailto:hello@moonshotmap.com"}>
              Book a Demo <FaArrowRight />
            </button>
          </div>
        </div>
      </section>

      {/* Footer - Consistent with Landing Page */}
      <Footer />
      <LoginModal isOpen={showLoginModal} onClose={() => setShowLoginModal(false)} />
    </div>
  );
};

export default PricingPage;
